import {
  Component,
  OnInit,
  Inject,
  Injector,
  forwardRef,
  ElementRef,
  NgModule,
  HostListener,
  ViewEncapsulation
} from '@angular/core';
import { RouterModule } from '@angular/router';

import { OBarMenuModule, OBarMenuComponent } from './o-bar-menu.component';
import { OTranslateService } from '../../services';
import { OSharedModule } from '../../shared';
import { CommonModule } from '@angular/common';

export const DEFAULT_INPUTS_O_BAR_MENU_ITEM = [
  // title [string]: menu item title. Default: no value.
  'itemTitle: title',

  // tooltip [string]: menu group tooltip. Default: 'title' value.
  'tooltip',

  // icon [string]: material icon. Default: no value.
  'icon',

  // route [string]: name of the state to navigate. Default: no value.
  'route',

  // action [function]: function to execute. Default: no value.
  'action'
];


export class OBarMenuItemComponent implements OnInit {

  public static DEFAULT_INPUTS_O_BAR_MENU_ITEM = DEFAULT_INPUTS_O_BAR_MENU_ITEM;

  protected menu: OBarMenuComponent;
  protected translateService: OTranslateService;

  protected _itemTitle: string;
  protected _tooltip: string;
  protected _icon: string;
  protected _route: string;
  protected _action: Function;
  protected _restricted: boolean;
  protected _isHovered: boolean = false;

   onMouseover = () => this.isHovered = true;
   onMouseout = () => this.isHovered = false;

  constructor(
     menu: OBarMenuComponent,
    protected elRef: ElementRef,
    protected injector: Injector) {
    this.menu = menu;
    this.translateService = this.injector.get(OTranslateService);
  }

  public ngOnInit() {
    if (typeof (this.route) === 'string') {
      this.menu.getAuthGuardService().isRestricted(this.route)
        .then(restricted => this.restricted = restricted)
        .catch(err => this.restricted = true);
    } else {
      this.restricted = false;
    }

    if (!this.tooltip) {
      this.tooltip = this.itemTitle;
    }
    if (this.translateService) {
      this.translateService.onLanguageChanged.subscribe(() => {
        this.setDOMTitle();
      });
      this.setDOMTitle();
    }
  }

  setDOMTitle() {
    let tooltip = this.translateService.get(this.tooltip);
    this.elRef.nativeElement.setAttribute('title', tooltip);
  }

  collapseMenu(evt: Event) {
    if (this.menu) {
      this.menu.collapseAll();
    }
  }

  get itemTitle(): string {
    return this._itemTitle;
  }

  set itemTitle(val : string) {
    this._itemTitle = val;
  }

  get tooltip(): string {
    return this._tooltip;
  }

  set tooltip(val : string) {
    this._tooltip = val;
  }

  get icon(): string {
    return this._icon;
  }

  set icon(val : string) {
    this._icon = val;
  }

  get route(): string {
    return this._route;
  }

  set route(val : string) {
    this._route = val;
  }

  get action(): Function {
    return this._action;
  }

  set action(val : Function) {
    this._action = val;
  }

  get restricted(): boolean {
    return this._restricted;
  }

  set restricted(val : boolean) {
    this._restricted = val;
  }

  get isHovered(): boolean {
    return this._isHovered;
  }

  set isHovered(val : boolean) {
    this._isHovered = val;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'o-bar-menu-item',
  template: `
    <div class="fake-li mat-primary" *ngIf="!restricted" (click)="collapseMenu($event)"
      [class.fake-li-hover]="isHovered">
      <a *ngIf="!action && route" class="mat-list-item" [routerLink]="[ route ]">
        <md-icon *ngIf="icon" class="o-bar-menu-item-icon mat-24">{{ icon }}</md-icon>
        <div class="o-bar-menu-item-title">{{ itemTitle | oTranslate }}</div>
      </a>
      <a *ngIf="!route && action" class="mat-list-item" (click)="action()">
        <md-icon *ngIf="icon" class="o-bar-menu-item-icon mat-24">{{ icon }}</md-icon>
        <div class="o-bar-menu-item-title">{{ itemTitle | oTranslate }}</div>
      </a>
      <div *ngIf="!route && !action" class="o-bar-menu-item-text mat-list-item" >
        <md-icon *ngIf="icon" class="o-bar-menu-item-icon mat-24">{{ icon }}</md-icon>
        <div class="o-bar-menu-item-title">{{ itemTitle | oTranslate }}</div>
      </div>
    </div>
  `,
  styles: [`
    o-bar-menu-item .mat-list-item{display:flex;justify-content:flex-start;align-items:center;height:auto}o-bar-menu-item .o-bar-menu-item-text{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;box-sizing:border-box;font-size:16px;height:48px;padding:0 16px}o-bar-menu-item .o-bar-menu-item-icon{display:inline-block;margin:6px 10px 0px 0px}o-bar-menu-item .o-bar-menu-item-icon ~ .o-bar-menu-item-title{padding-left:0px}o-bar-menu-item .o-bar-menu-item-title{display:inline-block;position:relative;top:3px;padding-left:40px}
  `],
  inputs: [
    ...DEFAULT_INPUTS_O_BAR_MENU_ITEM
  ],
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: OBarMenuComponent, decorators: [{ type: Inject, args: [forwardRef(() => OBarMenuComponent), ] }, ]},
{type: ElementRef, },
{type: Injector, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'onMouseover': [{ type: HostListener, args: ['mouseover', ] },],
'onMouseout': [{ type: HostListener, args: ['mouseout', ] },],
};
}



export class OBarMenuItemModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [OBarMenuItemComponent],
  imports: [OSharedModule, CommonModule, RouterModule, OBarMenuModule],
  exports: [OBarMenuItemComponent],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
